(() => {
  function start() {
    document.querySelectorAll('[data-nv-planner]').forEach(root => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const model = root.querySelector('[data-nv-model]');
      const hours = root.querySelector('[data-nv-hours]');
      const result = root.querySelector('[data-nv-result]');
      const shop = root.querySelector('[data-nv-shop]');
      const format = number => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { maximumFractionDigits: 1 }).format(Math.floor(number * 10) / 10);
      function update() {
        const selected = model.selectedOptions[0];
        const value = Number(hours.value);
        shop.href = selected.dataset.url;
        if (!hours.value.trim() || !Number.isFinite(value) || value < 0.25 || value > 24) {
          hours.setAttribute('aria-invalid', 'true');
          result.textContent = root.dataset.error;
          return;
        }
        hours.removeAttribute('aria-invalid');
        const minimum = Number(selected.dataset.min) / value;
        const maximum = Number(selected.dataset.max) / value;
        const range = minimum === maximum ? format(minimum) : `${format(minimum)}–${format(maximum)}`;
        result.textContent = `${root.dataset.about} ${range} ${minimum === maximum && range === format(1) ? root.dataset.evening : root.dataset.evenings}`;
      }
      model.addEventListener('change', update);
      hours.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
